export * from './post-projekt.component';
export * from './post-projekt.component.module';